export default "__VITE_ASSET__HMuF_XER__"